/* Pensum — Ergänzungen zu theme.js
   Läuft eigenständig und braucht nichts aus theme.js. */
(function () {
  'use strict';

  /* ------------------------------------------------------------- Kopfzeile */

  // Beim Herunterscrollen fährt die Kopfzeile weg, beim Hochscrollen ist sie
  // sofort wieder da. Ganz oben bleibt sie immer stehen.
  function initHeader() {
    // Klebend ist der Sektions-Wrapper, nicht das <header> selbst — siehe die
    // Begründung in pensum.css. Die Klasse muss also dort landen.
    var inner = document.querySelector('.header--sticky');
    if (!inner) return;

    var header = inner.closest('.shopify-section--header') || inner;

    var letzte = window.pageYOffset || 0;
    var geplant = false;

    // Ohne Schwelle flackert die Kopfzeile bei jedem Ruckeln und beim Federn
    // am Seitenende. Der Freiraum hält sie im obersten Bereich sichtbar.
    var SCHWELLE = 6;
    var FREIRAUM = 90;

    function pruefen() {
      geplant = false;

      var jetzt = window.pageYOffset || 0;
      var diff = jetzt - letzte;

      if (Math.abs(diff) < SCHWELLE) return;

      if (jetzt < FREIRAUM || diff < 0) {
        header.classList.remove('header--tucked');
      } else {
        header.classList.add('header--tucked');
      }

      letzte = jetzt;
    }

    window.addEventListener('scroll', function () {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(pruefen);
    }, { passive: true });

    // Ist das Menü offen, darf die Kopfzeile nicht wegfahren — sonst
    // verschwindet der Schließen-Knopf mit ihr.
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-menu-toggle]')) {
        header.classList.remove('header--tucked');
      }
    });
  }

  /* --------------------------------------------------------- Menü-Schublade */

  // Die Kopfzeile wird zum Wegfahren per transform verschoben. Ein Vorfahre mit
  // transform wird aber zum Bezugsrahmen für position: fixed — und die
  // Schublade liegt im Markup des Kopfbereich-Abschnitts. Ihr `inset: 0` galt
  // dadurch nicht mehr für den Bildschirm, sondern für die Kopfzeile: Sie
  // erschien als schmaler Streifen oben statt bildschirmhoch von rechts.
  //
  // Deshalb wird sie direkt an <body> gehängt. Dort gibt es keinen
  // transformierten Vorfahren mehr.
  function drawerLoesen() {
    var drawer = document.getElementById('MenuDrawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  /* ----------------------------------------------------------- Druckvorlage */

  /* Hängt an jede personalisierte Bestellung eine Zeile „Druckvorlage" mit
     einem Link. Der Link öffnet /pages/druckvorlage und zeigt dort das
     Produktfoto mit dem Aufdruck an genau der Stelle, die der Kunde gewählt
     hat — damit in der Bestellung nicht nur Prozentzahlen stehen.

     Alle Werte werden aus dem bestehenden Seitenzustand gelesen. personalizer.js
     bleibt unangetastet: die versteckten Bestellfelder und die CSS-Variablen der
     Ebenen enthalten schon alles, was gebraucht wird. */

  function initDruckvorlage() {
    var root = document.querySelector('[data-pz]');
    if (!root) return;

    var formId = root.getAttribute('data-pz-form');
    /* ERST IN root, DANN IM GANZEN DOKUMENT (10.09.2026).

       Seit die Live-Vorschau im Galerie-Hauptbild liegt, haengt die Buehne
       NICHT mehr unter [data-pz] — personalizer.js verschiebt sie beim Binden
       dorthin (Suchwort „INS HAUPTBILD"). Diese Datei laeuft danach, fand die
       Buehne mit root.querySelector also nicht mehr, stieg unten am
       `if (!stage || !textLayer) return;` aus und legte das Feld
       properties[_Druckvorlage] NIE an.

       Folge waere gewesen: Jede Bestellung haette ihren Vorlagen-Link
       verloren. Aufgedeckt am 10.09. durch einen echten Kauf in den Warenkorb
       — im Warenkorb standen sechs Eigenschaften statt sieben, und am
       Live-Theme war das Feld vorhanden.

       Die Reihenfolge root-zuerst bleibt, damit ein Aufbau ohne Verschiebung
       (etwa ohne Galerie auf der Seite) unveraendert weiterlaeuft. */
    function suche(auswahl) {
      return root.querySelector(auswahl) || document.querySelector(auswahl);
    }

    var stage = suche('[data-pz-stage]');
    var photo = suche('[data-pz-photo]');
    var textLayer = suche('[data-pz-layer="text"]');
    var symbolLayer = suche('[data-pz-layer="symbol"]');
    if (!stage || !textLayer) return;

    function feld(name) {
      return root.querySelector('[data-pz-prop="' + name + '"]');
    }

    // Eigenes Feld, damit personalizer.js seine eigenen Felder weiter frei
    // verwaltet. Der Unterstrich hält die Zeile aus der Kundenansicht heraus:
    // im Warenkorb und in der Bestätigungsmail erscheint sie nicht, im
    // Adminbereich schon.
    var ziel = document.createElement('input');
    ziel.type = 'hidden';
    ziel.name = 'properties[_Druckvorlage]';
    ziel.setAttribute('data-pz-vorlage', '');
    ziel.disabled = true;
    if (formId) ziel.setAttribute('form', formId);
    root.appendChild(ziel);

    // Nur der Dateiname wandert in den Link; die Adresse davor setzt die
    // Vorlagenseite wieder zusammen. Sonst wird der Wert unnötig lang.
    function bilddatei() {
      if (!photo || photo.hidden || !photo.getAttribute('src')) return '';
      var pfad = photo.getAttribute('src').split('?')[0];
      return pfad.substring(pfad.lastIndexOf('/') + 1);
    }

    function prozent(el, name) {
      var wert = getComputedStyle(el).getPropertyValue(name).trim();
      var zahl = parseFloat(wert);
      return isNaN(zahl) ? null : Math.round(zahl * 10) / 10;
    }

    // Die Schriftgröße steht in px und bezieht sich auf die Bühnenbreite. Als
    // Anteil der Breite gilt sie auf der Vorlagenseite unabhängig davon, wie
    // groß das Bild dort dargestellt wird.
    function groesseAnteil(el) {
      var breite = stage.clientWidth;
      if (!breite) return null;
      var fs = parseFloat(getComputedStyle(el).getPropertyValue('--pz-fs'));
      if (isNaN(fs)) return null;
      var skala = parseFloat(getComputedStyle(el).getPropertyValue('--pz-layer-scale')) || 1;
      return Math.round((fs * skala / breite) * 1000) / 10;
    }

    function schrift(el) {
      var stil = getComputedStyle(el);
      // Der Aufdruck führt seine Schrift in --pz-font, das Zeichen in
      // --pz-symbol-font. Ohne den zweiten Griff blieb sf leer, und sowohl die
      // Vorlagenseite als auch der Warenkorb zeigten das Zeichen in einer
      // Ersatzschrift.
      var stapel = stil.getPropertyValue('--pz-font').trim()
        || stil.getPropertyValue('--pz-symbol-font').trim();
      // Nur der erste Name wird gebraucht — die Vorlagenseite kennt dieselben
      // Familien und hängt ihre eigenen Ausweichschriften an.
      return stapel.split(',')[0].replace(/["']/g, '').trim();
    }

    function bauen() {
      var textFeld = feld('text');
      var text = textFeld ? textFeld.value : '';
      var symbolFeld = feld('symbolchar');
      var zeichen = symbolFeld && !symbolFeld.disabled ? symbolFeld.value : '';

      // Ohne Aufdruck und ohne Zeichen gibt es nichts zu drucken.
      if (!text && !zeichen) {
        ziel.value = '';
        ziel.disabled = true;
        return;
      }

      var inkFeld = feld('inkhex');
      var teile = [];

      function setze(schluessel, wert) {
        if (wert === null || wert === undefined || wert === '') return;
        teile.push(schluessel + '=' + encodeURIComponent(wert));
      }

      setze('b', bilddatei());
      setze('t', text);
      setze('f', schrift(textLayer));
      setze('i', inkFeld ? String(inkFeld.value).replace('#', '') : '');

      // Zusaetzlich die Farbe, wie sie der Kunde in der Vorschau gesehen hat.
      // Der Konfigurator hebt sie fuer die Anzeige an; gedruckt wird nach dem
      // rohen Wert in i. Ohne diesen zweiten Wert wirkte derselbe Aufdruck im
      // Warenkorb matter als in der Vorschau.
      var angezeigt = getComputedStyle(textLayer).getPropertyValue('--pz-ink').trim();
      if (angezeigt) setze('ia', angezeigt.replace('#', ''));
      setze('x', prozent(textLayer, '--pz-layer-x'));
      setze('y', prozent(textLayer, '--pz-layer-y'));
      setze('z', groesseAnteil(textLayer));
      setze('l', getComputedStyle(textLayer).getPropertyValue('--pz-track').trim());

      /* Dieselbe Stelle, zweimal gemessen — und beide Zahlen werden gebraucht.

         x und y oben rechnen gegen die BÜHNE, also gegen das ganze Foto samt
         Rand. Genau so setzt die Vorlagenseite die Ebene, deshalb müssen sie
         so bleiben, sonst zeichnet sie falsch.

         Die Bestelleigenschaft _Anordnung Aufdruck rechnet dagegen gegen die
         KARTE (layoutDescription in personalizer.js). Das ist die Zahl, die
         der Fertigung nützt: Wo auf dem Kartenkörper sitzt der Aufdruck.

         Beim Vorgabewert des MagSafe ergibt das 63 % gegen 68 % — rund 4 mm
         Versatz auf einer 90 mm hohen Karte. Bis zum 01.09.2026 nannte dieselbe
         Bestellung beide Werte nebeneinander, ohne dass irgendwo stand, welcher
         gilt.

         Deshalb reist der Kartenwert als cx/cy mit, und die Vorlagenseite zeigt
         IHN in ihren Angaben an. Gerechnet wird er nicht neu, sondern aus dem
         Feld gelesen, das personalizer.js ohnehin schreibt — eine zweite
         Rechnung wäre die Stelle, an der die Zahlen wieder auseinanderlaufen. */
      var anordnung = feld('textlayout');
      if (anordnung && !anordnung.disabled && anordnung.value) {
        var werte = String(anordnung.value).match(/-?\d+(?:[.,]\d+)?/g);
        if (werte && werte.length >= 2) {
          setze('cx', werte[0].replace(',', '.'));
          setze('cy', werte[1].replace(',', '.'));
        }
      }

      if (zeichen && symbolLayer && !symbolLayer.hidden) {
        setze('s', zeichen);
        setze('sf', schrift(symbolLayer));
        setze('sx', prozent(symbolLayer, '--pz-layer-x'));
        setze('sy', prozent(symbolLayer, '--pz-layer-y'));
        setze('sz', groesseAnteil(symbolLayer));
      }

      ziel.value = window.location.origin + '/pages/druckvorlage#' + teile.join('&');
      ziel.disabled = false;
    }

    /* Zusammenfassen statt jedes Mal neu bauen.

       Der Beobachter unten horcht jetzt auch auf die Textebenen selbst, und
       die ändern sich beim Verschieben des Aufdrucks in jedem Bild. Ohne diese
       Klammer liefe die ganze Zusammenstellung — sechs getComputedStyle-Griffe
       samt Aufbau der Adresse — mitten im Ziehen mit. Ein Bild Aufschub macht
       aus einer Serie von Änderungen einen einzigen Aufbau; der Wert steht
       dann höchstens 16 ms später im Feld, und abgeschickt wird ohnehin erst
       beim Klick auf den Kaufknopf. */
    var geplant = false;
    function planen() {
      if (geplant) return;
      geplant = true;
      var lauf = function () {
        if (!geplant) return;       // der jeweils andere Weg war schneller
        geplant = false;
        bauen();
      };
      /* BEIDE Wege, wer zuerst kommt.

         requestAnimationFrame allein reicht nicht: In einem Hintergrund-Reiter
         haelt der Browser die Bildfolge an, und der Aufbau bliebe dann bis zur
         Rueckkehr liegen. Nachgemessen im eingebetteten Browser mit verborgenem
         Fenster: Die Druckvorlage blieb leer, obwohl ein Name im Feld stand.
         setTimeout laeuft dort weiter (nur gedrosselt) und holt es nach. */
      if (window.requestAnimationFrame) window.requestAnimationFrame(lauf);
      window.setTimeout(lauf, 30);
    }

    // personalizer.js schreibt seine Felder bei jeder Änderung neu. Statt dessen
    // Ablauf nachzubauen, wird hier auf genau diese Schreibvorgänge gehört.
    var beobachter = new MutationObserver(planen);
    ['text', 'inkhex', 'textlayout', 'symbolchar', 'symbollayout'].forEach(function (name) {
      var el = feld(name);
      if (el) beobachter.observe(el, { attributes: true, attributeFilter: ['value', 'disabled'] });
    });

    /* Und zusätzlich die TEXTEBENEN selbst.

       Warum das gebraucht wird: Die versteckten Bestellfelder tragen den Namen
       und die Anordnung, aber NICHT die Schrift, die Schriftgröße und die
       Laufweite — die stehen als CSS-Variablen auf der Ebene und werden hier
       aus dem gerechneten Stil gelesen. personalizer.js schreibt beides in
       derselben Runde, aber nicht in derselben Reihenfolge: Beim Einspielen
       eines gemerkten Entwurfs steht der Name schon im Feld, während die
       Vorschau noch nicht ausgemessen ist. Der Beobachter oben feuerte damit
       genau einmal — zu früh —, und in der Druckvorlage fehlten Schrift, Größe
       und Laufweite. Die Werkstatt hätte in einer anderen Schrift gedruckt, als
       der Kunde gewählt hat, und im Warenkorb hätte er unmittelbar vor der
       Zahlung ein Bild gesehen, das nicht zu seiner Bestellung passt.

       --pz-ink setzt personalizer.js auf dem Wurzelelement, alles andere auf
       der Ebene. Deshalb beide beobachten. */
    [textLayer, symbolLayer, root].forEach(function (el) {
      if (el) beobachter.observe(el, {
        attributes: true, attributeFilter: ['style', 'class', 'hidden']
      });
    });

    // Attributänderungen greifen nicht, wenn der Wert über die Eigenschaft
    // gesetzt wird — deshalb zusätzlich auf die sichtbaren Auslöser hören.
    root.addEventListener('input', planen);
    root.addEventListener('click', function () { window.setTimeout(planen, 0); });
    root.addEventListener('pointerup', function () { window.setTimeout(planen, 0); });
    document.addEventListener('change', function () { window.setTimeout(planen, 60); });

    bauen();
  }

  function boot() {
    drawerLoesen();
    initHeader();
    initDruckvorlage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Im Theme-Editor wird der Kopfbereich neu gezeichnet, dabei entsteht die
  // Schublade wieder an ihrem alten Platz. Also nochmal umhängen.
  document.addEventListener('shopify:section:load', function () {
    drawerLoesen();
  });
})();
